import * as React from 'react';
import {RouteComponentProps, withRouter} from "react-router";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

class CreateContactButton extends React.Component<RouteComponentProps<{}>, {}> {
	render() {
		return (
			<ButtonPrimary variant={"burgundy"}
						   label={"Create contact"}
						   onClick={() => this.props.history.push("/app/contacts/create")}/>
		);
	}
}

export default withRouter<{}>(CreateContactButton);